import {Component, Input, OnInit} from '@angular/core';
import {Subscription} from "rxjs";
import {Acquisto, Filter, VoceAcquisto} from "../_Models";
import {ClassicType} from "../../shared/models/ClassicType";
import {IDropdownSettings} from "ng-multiselect-dropdown";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ServerPaginationService} from "../../shared/_services/server-pagination.service";
import {Permission} from "../../Login/_guards/Permission";
import {ApiRestService} from "../api-rest.service";
import {AcquistiAggiunteEditComponent} from "../acquisti-aggiunte-edit/acquisti-aggiunte-edit.component";
import {StockImportComponent} from "../stock-import/stock-import.component";
import {ProdImportComponent} from "../prod-import/prod-import.component";
import {ToastrService} from "ngx-toastr";
import {ConflittiComponent} from "../conflitti/conflitti.component";

@Component({
  selector: 'app-lavorazioni',
  templateUrl: './lavorazioni.component.html'
})
export class LavorazioniGroupedComponent implements OnInit {
  subscriptions: Subscription = new Subscription();
  page = 1;
  pageSize = 50;
  pagesizeserver = 4
  newpagegenerated = 1;
  List: VoceAcquisto[] = [];
  collectionSize: number = 0;
  Stati: ClassicType[];
  StatiSelezionati: ClassicType[] = [{id: "TI", label: "Tutti"}] ;
  DropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField:'id',
    textField: 'label'
  };
  @Input() hasFiltri: boolean = true;
  @Input() isAddEnabled: boolean = true;
  @Input() isEditEnabled: boolean = true;
  @Input() Filtri: Filter = {page: 1, size: 10, stato: "T", periodo: false};


  constructor(
    private modalService: NgbModal,
    private paginationService: ServerPaginationService,
    public permission: Permission,
    private apirestservice: ApiRestService,
    private toastrService: ToastrService,
  ) { }

  ngOnInit(): void {
    this.refreshTable(1);
  }
  getPage(page: number) {
    this.page = this.paginationService.paginadellalista(page, this.pagesizeserver);
    const pagetosend = this.paginationService.getPage(page, this.newpagegenerated, this.pagesizeserver);
    if ((pagetosend - 1) % this.pagesizeserver === 0) {
      this.newpagegenerated = page;
      this.refreshTable(pagetosend);
    }
  }
  refreshTable(page: number) {
    this.apirestservice.PrimaNotaAcquistiStatiVoci().subscribe(data=> this.Stati = data ?? [])
    this.Filtri.gruppo = true;
    this.Filtri.size = this.pagesizeserver * this.pageSize;
    this.Filtri.page = (page - 1) / this.pagesizeserver + 1;
    this.Filtri.stato = this.StatiSelezionati?.length >0 ?this.StatiSelezionati[0]?.id: "T";
    this.apirestservice.PrimaNotaAcquistiVoci(this.Filtri).subscribe(data=>{
      this.collectionSize = data?.total;
      this.List = data?.data;
    });
  }
  ImportaStock() {
    let modale = this.modalService.open(StockImportComponent,{
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<StockImportComponent>modale.componentInstance).Uploaded.subscribe(data=> {
      modale.dismiss();
      this.checkImport(data);
      this.refreshTable(1);
    });
  }
  ImportaProd() {
    let modale = this.modalService.open(ProdImportComponent,{
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<ProdImportComponent>modale.componentInstance).Uploaded.subscribe(data=> {
      modale.dismiss();
      this.checkImport(data);
      this.refreshTable(1);
    });
  }

  checkImport(data){
    console.log(data);
    if(data?.body?.noimport?.length > 0) {
      var stringa = "";
      data?.body?.noimport?.forEach(element => {
        stringa = stringa + element + "\n\n\n";
      })
      alert("Questi prodotti non sono stati importati perche non è stata trovata nessuna coincidenza:  \n" + stringa)
    }
    if(data?.body?.acquisti?.length > 0){
      let conflitti_modal = this.modalService.open(ConflittiComponent,{
        centered: true,
        backdrop: 'static',
        size: 'xl',
      });
      (<ConflittiComponent>conflitti_modal.componentInstance).acquisti = data?.body?.acquisti;
      (<ConflittiComponent>conflitti_modal.componentInstance).stock = data?.body?.stock?.length>0 ? data?.body?.stock: undefined;
      (<ConflittiComponent>conflitti_modal.componentInstance).produzione = data?.body?.prod?.length>0 ? data?.body?.prod: undefined;
      (<ConflittiComponent>conflitti_modal.componentInstance).Uploaded.subscribe(data=> {
        conflitti_modal.dismiss();
        this.refreshTable(1);
      });
    }
  }

  Edit(item?: VoceAcquisto) {
    let modale = this.modalService.open(AcquistiAggiunteEditComponent,{
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<AcquistiAggiunteEditComponent>modale.componentInstance).isModal = true;
    (<AcquistiAggiunteEditComponent>modale.componentInstance).VoceAcquisto = item ?? new VoceAcquisto();
    (<AcquistiAggiunteEditComponent>modale.componentInstance).Saved.subscribe(voce=> {
      if(voce?.id) {
        this.apirestservice.PrimaNotaAcquistiVoceUpdate(voce).subscribe(data=>{
          this.refreshTable(1);
        })
      }
    });
  }
  delete(item: VoceAcquisto) {
    if (confirm("Sei sicuro di voler eliminare questo elemento?")) {
      //this.apirestservice.PrimaNotaAcquistiDelete({ id: item.id }).subscribe(() => this.refreshTable(this.newpagegenerated));
    }
  }

}
